// @flow
import { diff } from 'deep-object-diff'
import type { AssetsManifest } from 'core/types'
import { Logger } from 'utils/logger'
import { showUpdaterPopup } from 'features/updater'

const UpdaterLogger = Logger.get('Updater')

// Сколько должно быть переходов между аппками прежде чем обновим манифест
const DEFAULT_TRESHOLD_HISTORY_CHANGE = 5

/**
 * Сервис для отслеживания переходов между апками(!!!)
 * При загрузке манифеста следит за апдейтом приложеньки, если манифест имеет отличие с загруженным ранее
 * Манифест загружается каждые DEFAULT_TRESHOLD_HISTORY_CHANGE переходов между апками
 */
export class Updater {
  manifest: ?AssetsManifest = null

  isInvalidated: boolean = false

  treshold: number = DEFAULT_TRESHOLD_HISTORY_CHANGE

  commitCrossAppChangeLocation = (): void => {
    this.treshold -= 1
    UpdaterLogger.debug('Reduce treshold by cross-app history change', this.treshold)

    if (this.treshold === 0) {
      UpdaterLogger.debug('Treshold is touched. Invalidate manifest.')
      this.isInvalidated = true
      this.treshold = DEFAULT_TRESHOLD_HISTORY_CHANGE
    }
  }

  setChangeLocationTreshold = (treshold: number): void => {
    this.treshold = treshold
  }

  getAppManifest = async (): Promise<AssetsManifest> => {
    if (this.manifest !== null && this.manifest !== undefined && this.isInvalidated === false) return this.manifest

    UpdaterLogger.debug('Load manifest')
    const manifestResponse = await fetch('/manifest.json', { cache: 'no-store' })
    const manifest: AssetsManifest = await manifestResponse.json()

    if (this.manifest && Updater.manifestChanged(this.manifest, manifest)) {
      showUpdaterPopup()
    }

    this._updateManifest(manifest)

    return manifest
  }

  /**
   * Compare two manifest with deep diff
   * @param {AssetsManifest} oldManifest
   * @param {AssetsManifest} newManifest
   */
  static manifestChanged(oldManifest: AssetsManifest, newManifest: AssetsManifest): boolean {
    const _diff = diff(oldManifest, newManifest)

    return Object.keys(_diff).length > 0
  }

  /**
   * Update manifest
   * @param {AssetsManifest} manifest
   */
  _updateManifest(manifest: AssetsManifest): void {
    this.isInvalidated = false
    this.manifest = manifest
  }
}
